"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosComplianceLicenseUpdateInputSchema = exports.APosComplianceLicenseCreateInputSchema = exports.APosComplianceLicenseSchema = exports.APosLicenseStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosLicenseStatusSchema = zod_1.z.enum(['active', 'pending', 'expired', 'suspended', 'revoked']);
exports.APosComplianceLicenseSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    licenseId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    licenseType: zod_1.z.string().min(1).max(100),
    licenseNumber: zod_1.z.string().min(1).max(100),
    issuingAuthority: zod_1.z.string().min(1).max(200),
    issuedDate: zod_1.z.number(),
    expiryDate: zod_1.z.number(),
    renewalDate: zod_1.z.number().optional(),
    status: exports.APosLicenseStatusSchema.default('active'),
    documentUrl: zod_1.z.string().url().optional(),
    documentKey: zod_1.z.string().optional(),
    notes: zod_1.z.string().max(2000).optional(),
    autoRenew: zod_1.z.boolean().default(false),
    reminderDays: zod_1.z.number().int().nonnegative().default(30),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosComplianceLicenseCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    licenseType: zod_1.z.string().min(1).max(100),
    licenseNumber: zod_1.z.string().min(1).max(100),
    issuingAuthority: zod_1.z.string().min(1).max(200),
    issuedDate: zod_1.z.number(),
    expiryDate: zod_1.z.number(),
    renewalDate: zod_1.z.number().optional(),
    documentUrl: zod_1.z.string().url().optional(),
    documentKey: zod_1.z.string().optional(),
    notes: zod_1.z.string().max(2000).optional(),
    autoRenew: zod_1.z.boolean().optional(),
    reminderDays: zod_1.z.number().int().nonnegative().optional(),
});
exports.APosComplianceLicenseUpdateInputSchema = exports.APosComplianceLicenseCreateInputSchema.partial().extend({
    status: exports.APosLicenseStatusSchema.optional(),
});
//# sourceMappingURL=compliance-license.schema.js.map